<template>
  <div class="payout-detail-modal">
    <el-dialog :title="$t('data.payout_details')" :visible.sync="dialogTableVisible" width="1000px" class="diglog-card" @open="getDetailInfo">
      <div v-if="$store.getters.isPii" class="header-line" />
      <template v-if="merchantInfo.transaction_type === TRANSACTION_TYPE_FX">
        <div class="total">
          <div class="total-item">
            <div class="total-title">{{ $t('data.destination_amount') }}:</div>
            <div class="total-num"> {{ merchantInfo.destination_currency }}  {{ merchantInfo.destination_amount | toDivideWithDot }}</div>
          </div>
          <div class="line" />
          <div class="total-item">
            <div class="total-title">{{ $t('data.fee') }}:</div>
            <div class="total-num">{{ merchantInfo.mch_foreign_exchange_fee_resp.fee_split_currency }}  {{ merchantInfo.mch_foreign_exchange_fee_resp.fee_split | toDivideWithDot }}</div>
          </div>
        </div>
        <div class="total">
          <div class="total-item">
            <div class="total-title">{{ $t('data.source_amount') }}:</div>
            <div class="total-num">{{ merchantInfo.source_currency }}  {{ merchantInfo.source_amount | toDivideWithDot }}</div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="total">
          <div class="total-item">
            <div class="total-title">{{ $t('data.destination_amount') }}:</div>
            <div class="total-num"> {{ $store.getters.currency }}  {{ merchantInfo.po_trans_amount | toDivideWithDot }}</div>
          </div>
          <div class="line" />
          <div class="total-item">
            <div class="total-title">{{ $t('data.fee') }}:</div>
            <div class="total-num">{{ $store.getters.currency }}  {{ merchantInfo.fee_split | toDivideWithDot }}</div>
          </div>
        </div>
      </template>

      <div class="section-title">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payout_created') }}</span>
        <span class="content-blue">{{ $t('data.payout_completed') }}</span>
      </div>

      <div class="item">
        <span class="item-left" style="color: #4B5567">{{ merchantInfo.transaction_create_time }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
      </div>

      <div class="section-title">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_id }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.merchant_order_id') }}</span>
        <span class="content-gray">{{ merchantInfo.merchant_order_id }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.remitting_bank') }}</span>
        <span class="content-gray">{{ merchantInfo.sender_bank_name }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.remittance_account') }}</span>
        <span class="content-gray">{{ merchantInfo.sender_bank_account | strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_name') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_name | strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_channel') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_channel || '-' }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_account') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_account | strAesDecryptAndAsterisk }}</span>
      </div>

      <div v-if="merchantInfo.sender_bank_name !== 'PYVIO' " class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.beneficiary_mobile') }}</span>
        <span class="content-gray">{{ merchantInfo.mobile | strAesDecryptAndAsterisk }}</span>
      </div>

      <div v-if="$store.getters.curCountry.country_code === 'AE'" class="item">
        <span class="item-left content-blue">{{ $t('map.benefit_address') }}</span>
        <span class="content-gray">{{ merchantInfo.beneficiary_address }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('system.remark') }}</span>
        <span class="content-gray">{{ merchantInfo.remark }}</span>
      </div>
      <template v-if="merchantInfo.transaction_type === TRANSACTION_TYPE_FX">
        <div class="item">
          <span class="item-left content-blue">{{ $t('data.quote_id') }}</span>
          <span class="content-gray">{{ merchantInfo.quote_id }}</span>
        </div>

        <div class="item">
          <span class="item-left content-blue">{{ $t('data.exchange_rate') }}</span>
          <span class="content-gray">{{ merchantInfo.exchange_rate }}</span>
        </div>

        <div class="item">
          <span class="item-left content-blue">{{ $t('data.exchange_transaction_id') }}</span>
          <span class="content-gray">{{ merchantInfo.exchange_no }}</span>
        </div>
      </template>

      <div v-if="merchantInfo.po_trans_status === TRANSACTION_STATUS['fail']" class="item">
        <span class="item-left content-blue">{{ $t('data.fail_reason') }}</span>
        <span class="content-gray">{{ merchantInfo.fail_reason }}</span>
      </div>

      <!-- <div class="item">
        <span class="item-left content-blue">{{ $t('merchant.payment_channel') }}</span>
        <span class="content-gray">{{ merchantInfo.channel_code }}</span>
      </div> -->

      <!-- <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.app_name') }}</span>
        <span class="content-gray">{{ merchantInfo.app_name }}</span>
      </div> -->

      <el-tag :type="getPOTransactionStatusType(merchantInfo.po_trans_status)" min-width="150" :class="{'payout-status':true, 'tag-custom':true,'is-pii':$store.getters.isPii}"> {{ getPOTransactionStatusLabel(merchantInfo.po_trans_status,merchantInfo.refund_type) }}</el-tag>
    </el-dialog>
  </div>
</template>

<script>
import { fetchPayoutDetail } from '@/api/customer-service/customer-service'
import { poTransStatusWithRefundMap } from '@/utils/maps'
// import { cryptoJSAesDecrypt } from '@/utils'
export default {
  name: 'Po_Details_Modal',
  components: {
  },
  props: {
    detailId: {
      type: String,
      default: '0'
    }
  },
  data() {
    this.TRANSACTION_STATUS = {
      fail: 4
    }
    this.TRANSACTION_TYPE_FX = 4
    return {
      dialogTableVisible: false, // 控制弹框显示隐藏
      listLoading: false,
      merchantInfo: { mch_foreign_exchange_fee_resp: {}} // 用户基本信息
    }
  },
  computed: {
    getPOTransactionStatusLabel() {
      return function(value, refund_type) {
        if (refund_type === 2) {
          value = 99
        }
        return poTransStatusWithRefundMap(value).label
      }
    },
    getPOTransactionStatusType() {
      return function(value) {
        return poTransStatusWithRefundMap(value).type
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo() {
      const params = { transaction_id: this.detailId }
      fetchPayoutDetail(params).then(res => {
        this.merchantInfo = res.data
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogTableVisible = value
    },

    onClickCancal() {
      this.changModalStatus(false)
    }
  }
}
</script>
<style>
.payout-detail-modal .el-dialog__title {
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 16px;
  color: #000000;
}
.payout-detail-modal .header-line{
  margin: -26px 0 0;
  border-bottom: 1px solid #D3D7DF;
}
</style>
<style scoped lang="scss">
.total{
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .total-item{
    flex: 1;
    min-width: 0;
  }
  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    margin: 0 16px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
    word-break: break-all;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 17px;
  background: linear-gradient(180deg, #488CE8 0%, #0058CF 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;;
}
.content-gray{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.payout-detail-modal{
  .payout-status{
    text-align: center;
    position: absolute;
    top: 10px;
    left: 160px;
  }
  .is-pii{
    top: 15px;
  }
}
</style>
